import React from 'react';
import { XCircle } from 'lucide-react';
import SubModal from './SubModal';

/**
 * Props:
 *  - show           {bool}
 *  - onClose        {function}  "Cancel" / backdrop / X
 *  - reason         {string}    e.g. "Transaction Timeout"
 *  - onRetryPayment {function}
 */
const PaymentFailedModal = ({ show, onClose, reason, onRetryPayment }) => (
  <SubModal show={show} onClose={onClose}>
    <div className="sub-icon-wrap danger">
      <XCircle size={26} />
    </div>
    <h3 className="sub-modal-title">Payment Failed</h3>

    <div className="sub-info-box">
      <span className="sub-info-label">Reason</span>
      <span className="sub-info-value">{reason}</span>
    </div>

    <p className="sub-modal-text">Please retry payment.</p>

    <div className="sub-actions">
      <button
        type="button"
        className="btn bg-dg c-w fw-semibold py-2"
        onClick={() => { onRetryPayment?.(); onClose?.(); }}
      >
        Retry Payment
      </button>
      <button type="button" className="sub-btn-ghost" onClick={onClose}>
        Cancel
      </button>
    </div>
  </SubModal>
);

export default PaymentFailedModal;
